import { TValueOfStringRecord } from '@interfaces/common/genericWithModifying';

export const EParametersFormValues = {
	vendor: 'vendor',
	technology: 'technology',
	version: 'version',
	type: 'type',
	nodeType: 'nodeType',
	sites: 'sites',
	nodes: 'nodes',
	dataSourceCreatedAtFirst: 'dataSourceCreatedAtFirst',
	dataSourceCreatedAtSecond: 'dataSourceCreatedAtSecond',
	isFirstCurrentDate: 'isFirstCurrentDate',
	isSecondCurrentDate: 'isSecondCurrentDate',
} as const;

export type TParametersFormValues = TValueOfStringRecord<typeof EParametersFormValues>
